<template>
  <div class="top"><img src="/energy-frontend/recycle.png" width="50" height="50"> <span>EcoTracker</span><img src="/energy-frontend/recycle.png" width="50" height="50"></div>
</template>

<script>
export default {
    name:"topBar"
}
</script>

<style >
.top{
  display: flex;
  justify-content:space-around;
  align-content: center;
  padding: 0px;
  font-size: 500%;
  font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; 
  align-items: center;



}
</style>